import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '../mui/Core/index'

function NoResultsFoundTableOverlay({ filterByDescription, noResultsValue }) {
  const rootStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  }

  return (
    <Box sx={rootStyle}>
      <Typography variant='message'>{`Searching for ${filterByDescription} "${noResultsValue}" returned 0 results.`}</Typography>
    </Box>
  )
}

NoResultsFoundTableOverlay.propTypes = {
  filterByDescription: PropTypes.string.isRequired,
  noResultsValue: PropTypes.string.isRequired,
}

export default NoResultsFoundTableOverlay
